import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const ViewAllPeptidesBlock = () => {
  const navigate = useNavigate();

  return (
    <section className="w-full py-12 md:py-16 lg:py-20 bg-[var(--color-background)]">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-center">
          <button
            onClick={() => navigate('/product-catalog')}
            className="group relative overflow-hidden rounded-2xl border-2 border-[rgba(0,212,255,0.3)] bg-[var(--color-card)] backdrop-blur-xl cursor-pointer transition-all duration-300 hover:border-[rgba(0,212,255,0.6)] hover:shadow-[0_0_40px_rgba(0,212,255,0.3)] hover:-translate-y-1 px-12 py-8 md:px-16 md:py-12"
          >
            {/* Background Glow */}
            <div className="absolute inset-0 bg-gradient-to-r from-[rgba(0,212,255,0.1)] to-[rgba(99,102,241,0.1)] opacity-50 transition-opacity duration-300 group-hover:opacity-80"></div>
            
            {/* Content */}
            <div className="relative flex flex-col items-center gap-4">
              <div className="flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-xl bg-gradient-to-br from-[#00D4FF] to-[#6366F1] shadow-lg transition-transform duration-300 group-hover:scale-110">
                <Icon name="Package" size={32} color="#FFFFFF" />
              </div>
              
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[var(--color-foreground)] group-hover:text-[var(--color-primary)] transition-colors duration-300">
                VIEW ALL PEPTIDES
              </h2>
              
              <div className="flex items-center gap-2 text-[var(--color-primary)] transition-transform duration-300 group-hover:translate-x-2">
                <span className="text-base md:text-lg font-medium">Explore Collection</span>
                <Icon name="ArrowRight" size={20} />
              </div>
            </div>

            {/* Hover Glow Effect */}
            <div className="absolute inset-0 bg-gradient-to-br from-[var(--color-primary)] to-[var(--color-secondary)] opacity-0 blur-3xl transition-opacity duration-300 group-hover:opacity-20"></div>
          </button>
        </div>
      </div>
    </section>
  );
};

export default ViewAllPeptidesBlock;